import * as React from 'react';
import Svg, { Circle, Path, SvgProps } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';

const SvgComponent = (props: SvgProps) => (
    <Svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
        <Circle cx={10} cy={10} r={10} fill={ds.colorValue.icon.tertiary} />
        <Path
            d="M10.0003 5.625C7.08366 5.625 5.91699 7.95833 5.91699 10.875V13.7917L8.25033 12.625L10.0003 13.7917L11.7503 12.625L14.0837 13.7917V10.875C14.0837 7.95833 12.917 5.625 10.0003 5.625Z"
            stroke="white"
            strokeWidth={2}
            strokeLinejoin="round"
        />
    </Svg>
);
export { SvgComponent as CircleGhost };
